import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class Slug extends Component {
  constructor() {
    super();

    this.renderTitle = this.renderTitle.bind(this);
  }

  shouldComponentUpdate() {
    return false;
  }

  renderTitle(title) {
    let classes = ['slug'];
    const { advertorial, className } = this.props;

    if (advertorial) {
      classes.push('slug--advertorial');
    }

    if (className) {
      classes.push(` ${className}__slug`);
    }

    classes = classes.join(' ');

    if (className === 'category-page' || className === 'tag-page') {
      return <h1 className={classes}>{title}</h1>;
    }

    return <h2 className={classes}>{title}</h2>;
  }

  render() {
    if (!this.props) {
      return null;
    }

    const { slugName, className, linkTo } = this.props;
    const title = slugName
      ? slugName.replace(/\*/g, '').replace(/_/g, ' ')
      : '';
    const hasLink = linkTo ? linkTo.length : false;
    const slugClasses = `slug-component${className
      ? ` ${className}__slug-component`
      : ''}`;

    if (hasLink) {
      return (
        <a href={linkTo} className={slugClasses}>{this.renderTitle(title)}</a>
      );
    }

    return <div className={slugClasses}>{this.renderTitle(title)}</div>;
  }
}

Slug.defaultProps = {
  slugName: '',
  className: '',
  linkTo: '',
  advertorial: false
};

Slug.propTypes = {
  slugName: PropTypes.string,
  className: PropTypes.string,
  linkTo: PropTypes.string,
  advertorial: PropTypes.bool
};



// WEBPACK FOOTER //
// ./src/views/components/slug/slug.js